import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { setEverestAuth } from "../app/features/everestAuthSlice";

// The DMS desktop host embeds this SPA in a WebView2. Bridge messages travel via
// window.chrome.webview; there is no cross-origin iframe parent to talk to.
// Contract (see docs/IDEAL-SaleTax-Integratio.md):
//   SPA -> DMS: window.chrome.webview.postMessage({ EVENT_TYPE: "REQUEST_EVEREST_CODE" })
//   DMS -> SPA: coreWebView2.PostWebMessageAsJson({ EVENT_TYPE: "EVEREST_CODE", code })
export function useCaptureEverestCode(): boolean {
  const dispatch = useAppDispatch();
  const credentialsReady = useAppSelector((s) => !!s.everestAuth.code);

  useEffect(() => {
    const bridge = (window as any).chrome?.webview;
    if (!bridge) {
      // Dev-only fallback: allow `?code=...` when running outside the WebView2 host.
      if (process.env.NODE_ENV !== "production") {
        const code = new URLSearchParams(window.location.search).get("code");
        if (code) dispatch(setEverestAuth({ code }));
      }
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      const data = event.data;
      if (
        data?.EVENT_TYPE === "EVEREST_CODE" &&
        typeof data.code === "string"
      ) {
        dispatch(setEverestAuth({ code: data.code }));
      }
    };

    bridge.addEventListener("message", handleMessage);
    bridge.postMessage({ EVENT_TYPE: "REQUEST_EVEREST_CODE" });

    return () => bridge.removeEventListener("message", handleMessage);
  }, [dispatch]);

  return credentialsReady;
}
